<template>
  <div class="hcl-tiles-editor" :class="{ dragging: dragging.active }">
    <hcl-tiles-editor-layout ref="editorRef" class="separator" :tiles="props.tiles" :dragging="dragging"
      :dimensions="dimensions" />
    <hcl-tiles-editor-chooser :tiles="tiles" :dimensions="dimensions" :dragging="dragging"
      v-on:dragging-change-active="onDraggingChangeActive" v-on:dragging-change-cancelled="onDraggingChangeCancelled"
      v-on:dragging-change-index="onDraggingChangeIndex" v-on:dragging-change-all="onDraggingChangeAll" />
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted } from 'vue'

import HclTilesEditorLayout from '@/components/TilesEditorLayout/TilesEditorLayout.vue'
import HclTilesEditorChooser from '@/components/TilesEditorChooser/TilesEditorChooser.vue'

interface Props {
  /**
   * Definition as an JS object.
   */
  tiles: any
}

const props = withDefaults(defineProps<Props>(), {
  tiles: undefined
})

const editorRef = ref()

const dragging = reactive({
  active: false,
  cancelled: false,
  index: 0
})

const onDraggingChangeActive = (event) => {
  dragging.active = event
}

const onDraggingChangeCancelled = (event) => {
  dragging.cancelled = event
}

const onDraggingChangeIndex = (event) => {
  dragging.index = event
}

const onDraggingChangeAll = (event) => {
  dragging.active = event.active
  dragging.cancelled = event.cancelled
  dragging.index = event.index
}

const dimensions = reactive({
  height: 0,
  width: 0
})

onMounted(() => {
  dimensions.height = editorRef.value.$el.clientHeight
  dimensions.width = editorRef.value.$el.clientWidth
})
</script>

<style lang="scss" scoped>
.hcl-tiles-editor {
  width: 100%;
}
</style>
